import {Energy} from '../../../Domain/Energy';

export function formatToKiloCalories(energy: Energy | null): {formatted: string; unit?: string} {
    if (energy === null) {
        return {formatted: 'n/a'};
    }

    if (energy.kilocalories < 100) {
        const formatter = new Intl.NumberFormat('en-UK', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        });
        return {formatted: formatter.format(energy.kilocalories), unit: 'kcal'};
    }

    const formatter = new Intl.NumberFormat('en-UK', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    return {formatted: formatter.format(energy.kilocalories), unit: 'kcal'};
}
